import type { ModuleInjectionTable } from '@open-mercato/shared/modules/widgets/injection'

export const injectionTable: ModuleInjectionTable = {
  'freight.cargo.detail:tabs': [
    {
      widgetId: 'cim.injection.cim-waybills-tab',
      kind: 'tab',
      groupLabel: 'CIM Waybills',
      priority: 30,
    },
  ],
}

export default injectionTable
